"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemBoxDescription = void 0;
var _mui = require("@ori-ui/mui");
var _shared = require("../../shared");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        lineHeight: 1.4,
        fontSize: theme.typography.caption.fontSize,
        overflow: 'hidden',
        padding: theme.spacing(1, 2)
    };
});
const Description = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.text.primary,
        marginTop: 2,
        ...(0, _shared.textStyles)(theme),
        ...(0, _shared.lineClampStyles)(2)
    };
});
const ItemCode = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        display: 'block',
        ...(0, _shared.textStyles)(theme)
    };
});
const Prices = (0, _mui.styled)('div')((param)=>{
    let { theme, ownerState: { isDoubleCurrency } } = param;
    return {
        position: 'absolute',
        bottom: 0,
        display: 'flex',
        marginBottom: theme.spacing(2),
        ...isDoubleCurrency && {
            flexDirection: 'column'
        }
    };
});
const Price = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return (0, _shared.priceStyles)(theme);
});
const OriginalPrice = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme, ownerState: { isDoubleCurrency } } = param;
    return {
        ...(0, _shared.originalPriceStyles)(theme),
        ...isDoubleCurrency && {
            order: -1
        }
    };
});
const ItemBoxDescription = (param)=>{
    let { isDoubleCurrency, itemCode, name, price, priceColor, purchasePrice } = param;
    const ownerState = {
        isDoubleCurrency
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Description, {
                variant: "caption",
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItemCode, {
                variant: "caption",
                color: "grey.A700",
                children: itemCode
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Prices, {
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Price, {
                        variant: "caption",
                        color: priceColor,
                        fontWeight: "bold",
                        children: price
                    }),
                    price !== purchasePrice && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OriginalPrice, {
                        variant: "caption",
                        ownerState: ownerState,
                        children: purchasePrice
                    })
                ]
            })
        ]
    });
};
exports.ItemBoxDescription = ItemBoxDescription;
